import React from 'react';
import GenericSearchBar from './GenericSearchBar';
import { Box, Typography } from '@mui/material';

const CongressSearchBar = ({ 
  onRepresentativeSelect, 
  maxRepresentatives = Infinity, 
  currentRepresentatives = [],
  disabled = false,
  hideSearch = false,
  ...props 
}) => {
  // Simple renderer for representative items in dropdown
  const renderRepresentativeItem = (result) => (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle1" component="span" fontWeight="bold">
          {result}
        </Typography>
        <Typography 
          variant="caption" 
          component="span"
          sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
        >
          Representative
        </Typography>
      </Box>
    </Box>
  );

  return (
    <GenericSearchBar
      onResultSelect={onRepresentativeSelect}
      maxSelections={maxRepresentatives}
      currentSelections={currentRepresentatives}
      searchEndpoint="/api/congress/representatives"
      placeholder="Search representatives..."
      queryParam="query"
      getResultValue={(result) => result} // Result is already a string
      renderResultItem={renderRepresentativeItem}
      disabled={disabled}
      hideSearch={hideSearch}
      minQueryLength={3}
      {...props}
    />
  );
};

export default CongressSearchBar;